import {
  type Company,
  CompanyManagerDepartmentEnum,
  type CreateCompanyAPIResponse,
  type GetCompanyAvailableProductsAPI,
  type GetCompanyManagersAPIResponse,
  Scopes,
  UserRoleType,
} from '@omnipresentgroup/types';

export const generateCompany = (override: Partial<Company>) => ({
  ...DEFAULT_COMPANY,
  ...override,
});

export const DEFAULT_COMPANY: Company = {
  countryOfRegistration: 'Spain',
  onboardingStage: 'Onboarding complete',
  managers: [
    {
      name: 'E2e Manager',
      id: 'def2967b-f6fa-48a7-82f0-cf82ecd8b5b3',
      scopes: [Scopes.employees_all, Scopes.expenses_notifications],
      department: CompanyManagerDepartmentEnum.Engineering,
      jobTitle: 'Senior Engineer',
    },
  ],
  invoicingEmail: 'e2e-manager@omnie2etesting.com',
  updatedBy: 'auth0|5f06da3e920eff001999e075',
  updatedAt: '2023-07-04T20:26:01.748Z',
  adminNotes: 'Wants employees to be paid in Dollars',
  needsManagerReview: false,
  isVATExempt: false,
  fxConversionPercent: '5',
  latePayment: {
    interestMargin: 8,
    amount: 250,
  },
  id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
  externalId: 'ETC',
  name: 'E2E test co',
  identifiers: {
    companyNumber: '67889',
    vatNumber: '123345',
  },
  primaryContact: {
    name: 'test',
    phoneNumber: '1111',
  },
  registeredAddress: {
    addressLine1: '123 Test apartment',
    city: 'London',
    postalCode: '11 890',
    country: '',
    addressLine2: 'Test Road',
    state: 'sdfsd',
  },
  createdAt: '2021-01-12T12:07:00.032Z',
  createdBy: '7880bcbe-f20e-4d07-bea8-2a2a1ef1ef5b',
  settings: {
    disableContractAutomation: false,
    enforceMFA: false,
  },
  enabledProducts: ['EOR', 'Contractor'],
};

export const COMPANIES: Company[] = [
  DEFAULT_COMPANY,
  generateCompany({
    id: 'adc8745b-f6fa-48a7-82f0-cf82ecdhydab',
    externalId: 'RDW',
    name: 'E2E RDW company',
  }),
];

export const CREATE_COMPANY_RESPONSE: CreateCompanyAPIResponse = {
  message: 'companies entity created',
  id: 'uurIBVliFK1E',
  url: 'https://2zrz23s8o9.execute-api.eu-west-2.amazonaws.com/companies/uurIBVliFK1E',
  createdManagers: [
    {
      id: 'bc43d7da-3f37-4248-8f01-4efd59eee6f7',
      name: 'Test Manager',
      scopes: [Scopes.employees_all, Scopes.expenses_notifications],
    },
  ],
};

export const DEFAULT_COMPANY_AVAILABLE_PRODUCTS: GetCompanyAvailableProductsAPI =
  {
    EOR: true,
    Contractor: false,
  };

export const DEFAULT_COMPANY_MANAGERS: GetCompanyManagersAPIResponse = [
  {
    userId: 'def2967b-f6fa-48a7-82f0-cf82ecd8b5b3',
    authId: 'auth0|5f06da3e920eff001999e075',
    firstName: 'E2e',
    lastName: 'Manager',
    displayName: 'E2E Manager',
    name: 'E2e Manager',
    email: 'e2e-manager@omnie2etesting.com',
    temporaryPassword: 'TWFuYWdlck9tbmk=',
    roles: [
      {
        tenantId: DEFAULT_COMPANY.id,
        id: DEFAULT_COMPANY.id,
        scopes: [
          'employees:*',
          'expenses:notifications',
          'finance:*',
          'payroll:*',
        ],
        type: UserRoleType.MANAGER,
      },
    ],
    seenWelcomeScreen: false,
    seenPrivacyPolicy: '2021-12-31T01:00:00.000Z',
    updatedBy: 'auth0|6350661c90c345b0acdb93c1',
    updatedAt: '2023-02-09T15:04:16.146Z',
  },
];
